import { lazy } from "react";

import { app } from "~/helpers/routes";
import { paths } from "~/router/paths";

const ProductDescription = lazy(() => import("~/pages/descriptions"));
const GenerateProductPage = lazy(() => import("~/pages/descriptions/generate"));

export const routes: Array<any> = [
  {
    path: paths.description.index,
    element: app(ProductDescription),
  },
  {
      path: paths.description.generate,
      element: app(GenerateProductPage)
    },
];
    